import social from './social.png';
import playlist from './playlist.png';
import stats from './stats.png';
import {PrimaryInfo} from '../util/util';
import {Link} from "react-router-dom";

interface LandingTileProps {
    image: string,
    text: string,
}

export const Home = () => {
    return (
        <div>
            <PrimaryInfo text={'Visualize your music journey.'}/>
            <div className={'flex flex-wrap justify-center items-start px-[1.2rem] pb-[1.2rem] portrait:mb-20'}>
                <Link to={'/stats'} className={'text-mm-cyan no-underline'}><LandingTile image={stats} text={'See in-depth stats about all your listening habits.'}/></Link>
                <Link to={'/playlist'} className={'text-mm-cyan no-underline'}><LandingTile image={playlist} text={'Get custom playlists recommended based on your stats.'}/></Link>
                <Link to={'/social'} className={'text-mm-cyan no-underline'}><LandingTile image={social} text={'Share your fun facts with all your friends any time.'}/></Link>
            </div>
        </div>
    );
}

const LandingTile = (props: LandingTileProps) => {
    return (
        <div className={'flex flex-col mx-[2.4rem] my-[1.2rem] border border-mm-text rounded-[0.3rem] text-[1.4rem] w-60 h-[22rem] cursor-pointer hover:w-[16.5rem] hover:h-[24.2rem] hover:text-[1.54rem] hover:transition-all hover:duration-500'}>
            <img src={props.image} alt={'Landing tile'} className={'w-full border-b-[0.12rem] border-mm-text'}/>
            <div className={'flex flex-col text-mm-text p-[0.65rem] justify-center text-center h-28'}>
              {props.text}
            </div>
        </div>
    );
}
